import React from 'react';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import styled from 'styled-components';
import { rgba } from 'polished';

export const CheckboxCircle = ({ id, ...restProps }) => (
  <React.Fragment>
    <Input type="checkbox" id={id} {...restProps} />
    <Label htmlFor={id} />
  </React.Fragment>
);

const Label = styled.label`
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;

  &:before {
    ${Mixins.transition('background-color, background-position, border-color')};
    content: '';
    display: inline-block;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 2px solid ${Colors.planoplan_blue};
    background-color: ${Colors.white};
    background-size: 18px 14px;
    background-position: center -18px;
    background-repeat: no-repeat;
    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE4IDE0Ij4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zIC01KSI+CiAgICA8cG9seWdvbiBwb2ludHM9IjAgMCAyNCAwIDI0IDI0IDAgMjQiLz4KICAgIDxwb2x5Z29uIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgcG9pbnRzPSI5IDE2LjE3IDQuODMgMTIgMy40MSAxMy40MSA5IDE5IDIxIDcgMTkuNTkgNS41OSIvPgogIDwvZz4KPC9zdmc+Cg==);
  }

  &:hover:before {
    border: 2px solid ${rgba(Colors.planoplan_blue, 0.6)};
  }
`;

const Input = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);

  &:checked + label:before {
    background-color: ${Colors.planoplan_blue};
    background-position: center center;
  }
`;
